import { createApi } from '@reduxjs/toolkit/query/react'
import { LIST_HOME_EDUCATION, CREATE_HOME_EDUCATION, DELETE_HOME_EDUCATION, VIEW_HOME_EDUCATION, EDIT_HOME_EDUCATION, EDIT_HOME_EDUCATION_BUDGET, ARCHIVE_HOME_EDUCATION, HOME_EDU_INTAKE_TEMPLATE, HOME_EDU_CREATE_INTAKE_REPORT, HOME_EDU_INTAKE_SEND, HOME_EDU_INTAKE_REMOVE, VIEW_HOME_EDUCATION_INTAKE, FAVOURITE_HOME_EDUCATION_CLIENT } from "config/apiPaths"
import { RTK_CACHE_EXPIRATION } from "config/constants"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const homeEducationApi = createApi({
    reducerPath: 'homeEducationApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client/home-education",
    }),
    tagTypes: ["HomeEducationList", "HomeEducationDetails"],
    keepUnusedDataFor: RTK_CACHE_EXPIRATION,
    endpoints: (builder) => ({
        // get home education list
        getHomeEducationList: builder.query({
            query: ({ search = "",therapist_id="", status = "", startDate = "", endDate = "", page = 1, limit = 10, divison = [], source = "", education_authority = "", sort = { column: "id", direction: "ASC" } }) => {
                return ({
                    method: "PATCH",
                    url: LIST_HOME_EDUCATION,
                    data: {
                        search,
                        therapist_id,
                        status: status?.value,
                        page,
                        limit,
                        divison,
                        sort,
                        startDate,
                        endDate,
                        education_authority,
                        source: source?.value
                    },
                })
            },
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["HomeEducationList"]
        }),

        // create home education client
        createHomeEducationClient: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: CREATE_HOME_EDUCATION,
                data
            }),
            invalidatesTags: ["HomeEducationList"]
        }),

        // delete home education client
        deleteHomeEducationClient: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${DELETE_HOME_EDUCATION}/${id}`
            }),
            invalidatesTags: ["HomeEducationList"]
        }),

        // home education client details
        getHomeEducationClientDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${VIEW_HOME_EDUCATION}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["HomeEducationDetails"]
        }),

        getHomeEducationIntakeDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${VIEW_HOME_EDUCATION_INTAKE}/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["HomeEducationDetails"]
        }),


        // update home education client
        updateHomeEducationClient: builder.mutation({
            query: ({ data, clientId }) => ({
                method: "PUT",
                url: `${EDIT_HOME_EDUCATION}/${clientId}`,
                data
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),

        updateHomeEducationStatus: builder.mutation({
            query: ({ status, clientId }) => ({
                method: "GET",
                url: `/${clientId}/${status}`,
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),

        // update home education client budget
        updateHomeEducationClientBudget: builder.mutation({
            query: ({ data, clientId }) => ({
                method: "PUT",
                url: `${EDIT_HOME_EDUCATION_BUDGET}/${clientId}`,
                data
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),

        // archive home education client
        archiveHomeEducationClient: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${ARCHIVE_HOME_EDUCATION}/${id}`
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),

        // get intake report template
        getIntakeTemplate: builder.query({
            query: () => ({
                method: "GET",
                url: `${HOME_EDU_INTAKE_TEMPLATE}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
        }),

        // Create intake report
        createIntakeReport: builder.mutation({
            query: ({ clientId, data }) => ({
                method: "PUT",
                url: `${HOME_EDU_CREATE_INTAKE_REPORT}/${clientId}`,
                data
            }),
            invalidatesTags: ["HomeEducationDetails"]
        }),

        // send intake
        sendIntake: builder.mutation({
            query: ({ clientId, email }) => ({
                method: "POST",
                url: `${HOME_EDU_INTAKE_SEND}/${clientId}`,
                data: { email }
            })
        }),

        // delete intake
        deleteIntake: builder.mutation({
            query: ({ intakeId, clientId }) => ({
                method: "DELETE",
                url: `${HOME_EDU_INTAKE_REMOVE}/${intakeId}/${clientId}`,
            })
        }),

        favouriteEducationfClient: builder.mutation({
            query: ({ data, id }) => ({
                method: "PATCH",
                url: `${FAVOURITE_HOME_EDUCATION_CLIENT}/${id}`,
                data
            }),
            invalidatesTags: ["HomeEducationList", "HomeEducationDetails"]
        }),
    }),
})

export const {
    useGetHomeEducationListQuery,
    useCreateHomeEducationClientMutation,
    useDeleteHomeEducationClientMutation,
    useGetHomeEducationClientDetailsQuery,
    useUpdateHomeEducationClientMutation,
    useUpdateHomeEducationClientBudgetMutation,
    useArchiveHomeEducationClientMutation,
    useLazyGetHomeEducationClientDetailsQuery,
    useGetIntakeTemplateQuery,
    useCreateIntakeReportMutation,
    useGetHomeEducationIntakeDetailsQuery,
    useSendIntakeMutation,
    useDeleteIntakeMutation,
    useUpdateHomeEducationStatusMutation,
    useFavouriteEducationfClientMutation
} = homeEducationApi;